import { useTranslation } from "../../../../../localization/useTranslation";
import { Trans } from "react-i18next";
import AssociatedInternalAssessmentDialog from "../../../../../common/components/questionnaireComponents/associatedInternalAssessmentDialog/AssociatedInternalAssessmentDialog";
import useSystemInternalAssessmentDialogHooks from "./SystemInternalAssessmentDialog.hooks";
import HighlightedName from "@common/components/HighlightedName";

export interface ISystemInternalAssessmentDialogProps {
    onDialogClose: () => void;
    systemName: string;
    systemId: string;
    existingInternalAssessments: Array<string>;
}

function SystemInternalAssessmentDialog(props: ISystemInternalAssessmentDialogProps) {
    const { translateString } = useTranslation();
    const { addAssociatedInternalAssessment, removeAssociatedInternalAssessment, selectedInternalAssessments } = useSystemInternalAssessmentDialogHooks(props);
    return (
        <AssociatedInternalAssessmentDialog
            onDialogClose={props.onDialogClose}
            name={props.systemName}
            dialogHeader={translateString("associateAssessmentToSystem")}
            dialogInfo={
                <Trans
                    i18nKey="associateAssessmentsToSystem"
                    values={{ name: props.systemName }}
                    components={{
                        wrapper: <HighlightedName />,
                    }}
                />
            }
            chosenOptions={selectedInternalAssessments}
            onAddInternalAssessment={addAssociatedInternalAssessment}
            onDeleteInternalAssessment={removeAssociatedInternalAssessment}
            existingInternalAssessments={props.existingInternalAssessments}
        />
    );
}

export default SystemInternalAssessmentDialog;
